import * as React from 'react';

import { connect } from 'react-redux';

import { FilterBase, mapDispatchToProps, mapStateToProps } from './filter-base';

export class FilterRadio extends FilterBase {
    convertEvtToString(evt: React.ChangeEvent<HTMLSelectElement>) {
        return evt.target.value;
    }

    submitChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        //this.updateValue(evt);
        this.boundFilterUpdate(this.convertEvtToString(evt), true);
    }

    renderFormElement() {
        return (
            <fieldset>
                <legend>{this.props.title}</legend>

                <ul className="adage-form-list adage-form-list-vertical">
                    {
                        this.props.defaultOption ? <li key={`${this.props.defaultOption.value}~${this.props.defaultOption.text}`}>
                            <input type="radio" id={`${this.props.title.replace(/ /g, '')}-${this.props.defaultOption.value.replace(/ /g, '')}-${this.props.defaultOption.text.replace(/ /g, '')}`} value={this.props.defaultOption.value} checked={this.props.selectedOptions ? false : this.props.selectedOptions === this.props.defaultOption.value} onChange={this.submitChange.bind(this)} />
                            <label htmlFor={`${this.props.title.replace(/ /g, '')}-${this.props.defaultOption.value.replace(/ /g, '')}-${this.props.defaultOption.text.replace(/ /g, '')}`}>{this.props.defaultOption.text}</label>
                        </li> : null
                    }
                    {
                        this.props.options.map(option => {
                            return (
                                <li key={`${option.value}~${option.text}`}>
                                    <input type="radio" id={`${this.props.title.replace(/ /g, '')}-${option.value.replace(/ /g, '')}-${option.text.replace(/ /g, '')}`} value={option.value} checked={!this.props.selectedOptions ? false : this.props.selectedOptions === option.value} onChange={this.submitChange.bind(this)} />
                                    <label htmlFor={`${this.props.title.replace(/ /g, '')}-${option.value.replace(/ /g, '')}-${option.text.replace(/ /g, '')}`}>{option.text}</label>
                                </li>
                            )
                        })

                    }
                </ul>
            </fieldset>
        )
    }
}

export const ConnectedFilterRadio = connect(mapStateToProps, mapDispatchToProps)(FilterRadio);